import { render } from "./FeedbackWidget.vue?vue&type=template&id=5442f3c2"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__